import getStore from '../store';

export default function removeUserMailboxInfo(mailboxId: string): void {
    const userMailboxInfoMap = getStore().userMailboxInfoMap;
    if (userMailboxInfoMap) {
        userMailboxInfoMap.delete(mailboxId);
    }
}
